import { regionLocaleLangs } from '../../config/intl';

export const getRegionLocaleLangs = (currLocale) => {
  const currRegion = currLocale.split('-')[1];
  return regionLocaleLangs.get(currRegion);
}